import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { ProducersCard } from '../components'

export const ProducersPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.producers.title')
        }
      ]}
      title={t('medicine_register.producers.title')}
    >
      <ProducersCard />
    </PageBreadcrumbs>
  )
}
